module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/bg.e084f647.jpg";